<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">tabs</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content> -->
<ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="patient">
      <ion-icon name="clipboard-outline"></ion-icon>
      <ion-label>Patient</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="staff">
      <ion-icon name="people-outline"></ion-icon>
      <ion-label>Staff</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>